import "mhead-js/dist/mhead.js"
import "mmenu-js/dist/mmenu.js"
import {debounce} from 'lodash'

if ($('.header-menu').length) {
    //@ts-ignore
    new Mhead('.header-menu', {
        // pin: 0,
        // unpin: false,
        // tolerance: 5
    });
}

if ($('.header-toolbar.mobile').length) {
    // @ts-ignore
    new Mhead('.header-toolbar.mobile', {
        // pin: 300,
        // unpin: 300,
        tolerance: 5
    });
}

const onScroll = () => {
    const $headerMenu = $('.header-menu')
    const scroll = window.scrollY;

    $headerMenu.toggleClass('bg', !!scroll)
}

window.addEventListener("scroll", debounce(onScroll, 50));
window.addEventListener("load", onScroll);

document.addEventListener(
    "DOMContentLoaded", () => {
        if (!$("#mmenu").length) {
            return
        }
        // @ts-ignore
        const menu = new Mmenu("#mmenu", {
            theme: "light",
            extensions: [
                'pagedim-black',
                'position-right',
                'border-full'
            ],
            iconPanels: false,
            offCanvas: {
                position: "right",

            },
            "navbars": [
                {
                    "position": "top",
                    "content": $('.header-toolbar .contacts .socials').clone().toArray()
                },
                {
                    "position": "top",
                    "content": $('.header-toolbar .contacts .phone').clone().toArray()
                }
            ]
        }, {
            language: 'ru',
            offCanvas: {
                page: {
                    selector: '#page-wrapper'
                }
            },
            classNames: {
                selected: "current-menu-item"
            },
        });

    }
);
